<script lang="ts">
	import type { Writable } from 'svelte/store';
	import type { Hub } from '$lib/api/rpc';

	export let hub: Writable<Hub>;
</script>

<h1 class="px-hub-name px-hub-title" style={`color: ${$hub.theme.coverFontColor}`}>
	{$hub.name}
</h1>

<style>
	h1 {
		margin: 0;
		font-size: var(--fontSizeLargest);
		font-weight: normal;
		letter-spacing: -0.4px;
		line-height: 3.6rem;
	}
</style>
